import React from "react";
import { AccountStore } from "../../stores/account";
import M from "../../strings";
import { connect } from "../utils/aj";
import { Screen } from "../components/layout";
import * as ui from "../utils/ui";
import { requestRecoveryCode, resetPassword, resetPasswordChange, validateRecoveryCode } from "../../actions/account";
import * as forms from "../utils/forms";
import { safeGet } from "../../utils/lang";
import _ from "underscore";
import { PasswordRecoveryStore } from "../../stores/passwordRecovery";
import MobileLayout from "../components/mobile/layout";
import { MobileInput, MobilePasswordInput } from "../components/mobile/forms";

export default class Recover extends Screen {
    constructor(props) {
        super(props);
        connect(this, [AccountStore, PasswordRecoveryStore]);
    }

    componentWillUnmount() {
        resetPasswordChange();
    }

    requestCode(data) {
        requestRecoveryCode(data);
        return false;
    }

    requestNewCode() {
        let data = {
            mail: this.state.mail,
        };
        this.requestCode(data);
        return false;
    }

    validateCode(data) {
        data.mail = this.state.mail;
        validateRecoveryCode(data);
        return false;
    }

    resetPassword(data) {
        _.assign(data,{mail: this.state.mail, code: this.state.code});
        resetPassword(data)
            .then(() => ui.navigate("/login"));
        return false;
    }

    getContent(){
        let recoveryStep = safeGet(this.state,"recoveryStep", 1);

        switch (recoveryStep) {
            case 1:
                return <CodeRequestForm
                    onSubmit = {this.requestCode.bind(this)}
                />;
            case 2:
                return <CodeValidationForm
                    onSubmit = {this.validateCode.bind(this)}
                    onTryAgain = {this.requestNewCode.bind(this)}
                />;
            case 3:
                return <PasswordChangeForm
                    onSubmit = {this.resetPassword.bind(this)}
                />;
            default:
                return (<div
                        className="login__action-link text-center"
                    >
                        <a
                            href="#/login"
                        >
                            {M("backToLogin")}
                        </a>
                    </div>)
        }
    }

    render() {
        const content = this.getContent();

        return(
            <MobileLayout
                hideHeader={true}
            >
                <div
                    className="container"
                >
                    <div
                        className="row justify-content-center"
                    >
                        <div
                            className="login__wrapper col-12 col-md-8 col-lg-6"
                        >
                            <div
                                className="login__logo"
                            >
                                <img
                                    src="resources/images/logo.svg"
                                />
                            </div>
                            <h4
                                className="login__header"
                            >
                                {M("recoverPassword")}
                            </h4>
                            {content}
                        </div>
                    </div>
                </div>
            </MobileLayout>
        )
    }
}

class CodeRequestForm extends React.Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    onSubmit(e) {
        e && e.preventDefault();
        let data = forms.serialize(this.formRef.current);
        if (_.isFunction(this.props.onSubmit)) {
            this.props.onSubmit(data);
        }
    }

    render() {
        return (
            <form
                ref={this.formRef}
                className="login__form"
                action=""
                onSubmit={this.onSubmit.bind(this)}
            >
                <p className="text-left">{M("accountRecoverText")}</p>
                <MobileInput
                    type="email"
                    name="mail"
                    label={M("mailAddress")}
                    placeholder={M("mailAddress")}
                />
                <div
                    className="login__action-link"
                >
                    <a
                        href="#/login"
                    >
                        {M("backToLogin")}
                    </a>
                </div>
                <div
                    className="login__btn"
                >
                    <button
                        type="submit"
                        className="btn btn-block btn-primary"
                    >
                        {M("submit")}
                    </button>
                </div>
            </form>
        )

    }
}

class CodeValidationForm extends React.Component {
    constructor(props){
        super(props);
        this.formRef = React.createRef();
    }

    onSubmit(e) {
        e && e.preventDefault();
        let data = forms.serialize(this.formRef.current);
        if (_.isFunction(this.props.onSubmit)) {
            this.props.onSubmit(data);
        }
    }

    onTryAgain() {
        if (_.isFunction(this.props.onTryAgain)) {
            this.props.onTryAgain();
        }
    }

    render(){
        return(
            <form
                ref={this.formRef}
                className="login__form"
                action=""
                onSubmit={this.onSubmit.bind(this)}
            >
                <p className="text-left">{M("codeValidationText")}</p>
                <MobileInput
                    type="text"
                    name="code"
                    label={M("validationCode")}
                    placeholder={M("validationCode")}
                />
                <div
                    className="login__action-link"
                >
                    <a
                        href="#/login"
                    >
                        {M("backToLogin")}
                    </a>
                </div>
                <div
                    className="login__btn"
                >
                    <button
                        type="submit"
                        className="btn btn-block btn-primary"
                    >
                        {M("submit")}
                    </button>
                </div>
                <div
                    className="login__btn"
                >
                    <button
                        type="button"
                        className="btn btn-block btn-outline-primary"
                        onClick={this.onTryAgain.bind(this)}
                    >
                        {M("resendCode")}
                    </button>
                </div>
            </form>
        )
    }
}

class PasswordChangeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.formRef = React.createRef();
    }

    onSubmit(e){
        e && e.preventDefault();
        let data = {
            password: this.state.password,
            passwordConfirm: this.state.passwordConfirm,
        };
        if (_.isFunction(this.props.onSubmit)) {
            this.props.onSubmit(data);
        }
    }

    updatePassword(e){
        this.setState({password: e.target.value});
    }

    updatePasswordConfirm(e){

        this.setState({passwordConfirm: e.target.value});
    }

    render(){
        return(
            <form
                ref={this.formRef}
                className="login__form"
                action=""
                onSubmit={this.onSubmit.bind(this)}
            >
                <p className="text-left">{M("newPasswordText")}</p>
                <MobilePasswordInput
                    name="password"
                    label={M("password")}
                    placeholder={M("password")}
                    onChange={this.updatePassword.bind(this)}
                />
                <MobilePasswordInput
                    name="password"
                    label={M("passwordConfirm")}
                    placeholder={M("passwordConfirm")}
                    onChange={this.updatePasswordConfirm.bind(this)}
                />
                <div
                    className="login__action-link"
                >
                    <a
                        href="#/login"
                    >
                        {M("backToLogin")}
                    </a>
                </div>
                <div
                    className="login__btn"
                >
                    <button
                        type="submit"
                        className="btn btn-block btn-primary"
                    >
                        {M("confirm")}
                    </button>
                </div>
            </form>
        )
    }
}